/**
 * Module 11's expiry badge, in one component so both dashboards say the same thing the
 * same way.
 *
 * <p>An expired window is an error, not information: the person cannot open anything
 * this morning, and a banner in the same calm lilac as "3 codes left" would understate
 * it. A window merely closing soon is information — there is a month to act, and a red
 * banner every day for thirty days is a banner nobody reads on day thirty.
 *
 * <p>Renders nothing while the window is healthy. A dashboard that always carries a
 * status line teaches people to ignore the line.
 */
export default function AccessExpiryBanner({ status, daysRemaining, what, action }) {
  if (status !== 'RENEWAL_DUE' && status !== 'SUSPENDED') {
    return null;
  }
  const expired = status === 'SUSPENDED';
  const days = Number(daysRemaining ?? 0);

  return (
    <div className={`banner ${expired ? 'banner-error' : 'banner-info'}`} role="status">
      <span>
        <strong>{what}</strong>{' '}
        {expired
          ? 'has expired.'
          : `ends in ${days} day${days === 1 ? '' : 's'}.`}{' '}
        {action}
      </span>
    </div>
  );
}
